import { createEffect, createEvent, createStore, sample } from 'effector';
import { USER_VARIABLE } from '@nx-frontend/shared/api';
import { clientSetUserVars } from '@nx-frontend/shared/api/webnotes/client';
import { $user } from '@nx-frontend/shared/store/user';
import { UserVar } from '@nx-frontend/shared/types';

export const initialUserVarsState: UserVar[] = [
  {
    key: USER_VARIABLE.DATE_TIME_LOCALE,
    value: 'en-US',
  },
];

export const $userVars = createStore(initialUserVarsState);

export const setUserVarsEvent = createEvent<UserVar[]>();

$userVars.on(setUserVarsEvent, (_, newUserVars) => newUserVars);

export const getUserVarValue = (userVars: UserVar[], key: string) => {
  const userVar = userVars.find((userVar) => userVar.key === key);
  if (!userVar) {
    return null;
  }
  if (!userVar.value) {
    return null;
  }
  return userVar.value ?? initialUserVarsState[0].value;
};

export const $dateTimeLocale = $userVars.map((userVars) => {
  return getUserVarValue(userVars, USER_VARIABLE.DATE_TIME_LOCALE);
});

export const $isShareSettingsOpened = $userVars.map((userVars) => {
  return getUserVarValue(userVars, USER_VARIABLE.SHARE_SETTINGS_OPENED);
});

export const $isShareAnalyticsShown = $userVars.map((userVars) => {
  return getUserVarValue(userVars, USER_VARIABLE.SHARE_ANALYTICS_SHOWN);
});

export const $isSubscriptionSelected = $userVars.map((userVars) => {
  return !!getUserVarValue(userVars, USER_VARIABLE.IS_SUBSCRIPTION_SELECTED);
});

export const $selectedSubscription = $userVars.map((userVars) => {
  return getUserVarValue(userVars, USER_VARIABLE.SELECTED_SUBSCRIPTION);
});

export const setUserVarEvent = createEvent<UserVar>();

$userVars.on(setUserVarEvent, (state, userVar) => {
  const newState = state.filter((stateUserVar) => stateUserVar.key !== userVar.key);
  newState.push(userVar);
  return newState;
});

const setUserVarFx = createEffect(async ({ userId, userVar }: { userId: number; userVar: UserVar }) => {
  await clientSetUserVars({
    key: userVar.key,
    value: userVar.value,
    userId,
  });
  return userVar;
});

sample({
  source: $user,
  clock: setUserVarEvent,
  fn: (user, userVar) => {
    return { userId: user.id, userVar };
  },
  target: setUserVarFx,
});
